<template>
  <footer>
    <div class="footerTop">
      <div class="content footerTopBox">
        <p class="footerTitle">{{ orgName }}</p>
        <div class="flex" v-if="hideInfo">
          <div class="msgBox">
            <p>工作时间：{{ orgExt && orgExt.workTime }}</p>
            <p>联系电话：{{ orgExt && orgExt.mobileNo }}</p>
          </div>
          <div class="line"></div>
          <div>
            <!-- <p>联系邮箱：187590830@163.com</p> -->
            <p>中心地址：{{ orgExt && orgExt.workAddr }}</p>
          </div>
        </div>
        <div class="support flex-align-center">
          <span>技术支持</span>
          <img src="../assets/imgs/home/footLogo.png" alt />
        </div>
      </div>
    </div>
    <div class="foot">Copyright@2015-2020 河南省非煤矿山管理办公室&中资互联网科技有限公司 All right Reserved</div>
  </footer>
</template>

<script>
export default {
  name: "foot",
  data () {
    return {
      orgName: "",
      orgExt: {
        workTime: "",
        mobileNo: "",
        workAddr: ""
      },
      hideInfo: false,
    };
  },
  created () {
    this.orgName = localStorage["orgName"] || "";
    if (localStorage.getItem('orgExt') != 'undefined') {
      this.hideInfo = true;
      this.orgExt = JSON.parse(localStorage["orgExt"]) || "";
    } else {
      this.hideInfo = false;
    }
  },
};
</script>

<style scoped lang="less">
footer {
  .footerTop {
    background: #f7f9fd;
    box-shadow: 0 1px 30px 0 rgba(0, 0, 0, 0.05);
    height: 125px;
    padding: 15px;
    .footerTopBox {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #616c84;
      letter-spacing: 0.22px;
      .footerTitle {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #616c84;
        letter-spacing: 0.26px;
        margin: 5px 0;
      }
      .line {
        width: 1px;
        height: 22px;
        background: #616c84;
        margin: 5px 20px;
      }
      .support {
        margin: 10px 0;
        img {
          margin-left: 10px;
        }
      }
    }
  }
  .foot {
    background: #153684;
    height: 30px;
    line-height: 30px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #ffffff;
    letter-spacing: 0.22px;
    text-align: center;
  }
}
</style>
